import { useMutation, useQueryClient } from '@tanstack/react-query';
import type { ZodCreateLeaveRequestInput } from '@functieloonhuis/shared';
import { verlofApi } from '../../../lib/verlofApi';
import { leaveKeys } from './useMijnVerlof';

/**
 * Story 1.3: submit a new leave request.
 *
 * Invalidation depends on WHOSE leave this was. A self-submit only changes
 * the own overview. A submission on behalf of someone else is immediately
 * approved and booked, so it also changes the approval queue and the
 * attendance calendar — without invalidating those, a colleague keeps
 * showing as present on a day that is now booked off.
 */
export function useSubmitLeaveRequest() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (input: ZodCreateLeaveRequestInput) => verlofApi.submit(input),
    onSuccess: (_data, variables) => {
      queryClient.invalidateQueries({ queryKey: leaveKeys.mine() });
      if (variables.employeeId !== undefined) {
        queryClient.invalidateQueries({ queryKey: ['leave-requests', 'approval-queue'] });
        queryClient.invalidateQueries({ queryKey: ['aanwezigheidskalender'] });
      }
    },
  });
}
